import { css } from 'styled-components';

export const carouselCSS = css`
  .slick-slide {
    vertical-align: top !important;
    #carouselItem {
      vertical-align: middle;
      text-align: center;
    }

    &.slick-active {
      height: 100%;
      #carouselItem {
        height: 100%;
        margin-bottom: 25px;
      }
    }

    &:not(.slick-active) {
      height: 25px;
      #carouselItem {
        height: 25px;
      }
    }

    img {
      display: initial;
    }
  }

  .carousel__control {
    top: 260px !important;
  }

  .carousel__control--left {
    left: 0;
  }

  .custom__control--left {
    left: 0;
  }

  .carousel__control--left.active {
    color: #333333;
    font-family: 'Vodafone', sans;
  }

  .carousel__control--left span {
    position: absolute;
    width: 170px;
    left: 45px;
    top: 15px;
    text-align: left;
    margin-left: 10px;
  }

  .custom__control--left {
    color: #333333;
    font-family: 'Vodafone', sans;
  }

  .backBtn {
    position: absolute;
  }

  .customBackBtn {
    position: absolute;
    width: 160px;
    text-align: left;
    margin-left: 10px;
  }

  .carousel__control--right {
    right: 0;
  }

  .carousel__control--right.active {
    color: #333333;
    font-family: 'Vodafone', sans;
  }

  .carousel__control--right span {
    position: absolute;
    width: 170px;
    right: 45px;
    top: 15px;
    text-align: right;
    margin-right: 10px;
  }

  .btn-disabled {
    pointer-events: none;
  }

  @media (max-width: 767px) {
    .carousel__control--left span {
      display: none;
    }
    .custom__control--left span {
      display: none;
    }
    .carousel__control--right span {
      display: none;
    }
    .carousel__control {
      top: 210px !important;
    }
    .sureyQueImage {
      width: 210px;
    }
  }
`;

export const goalsPageLoaderCSS = css`
  display: grid;
  place-content: center;
  height: 350px;
`;
